import { Controller, useFormContext } from 'react-hook-form';
import TextField, { TextFieldProps } from 'src/components/ui/TextField';

interface FormTextFieldProps extends Omit<
  TextFieldProps,
  'name' | 'isInvalid' | 'errorMessage' | 'validationBehavior'
> {
  name: string;
  onChangeEnd?: () => void;
}

const FormTextField = ({
  name,
  type,
  onChangeEnd,
  ...rest
}: FormTextFieldProps) => {
  const { control } = useFormContext();
  const isNumberField = type === 'number';

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { invalid, error } }) => (
        <TextField
          {...field}
          {...rest}
          onChange={(value) => {
            if (isNumberField) field.onChange(Number(value));
            else field.onChange(value);
            if (onChangeEnd) onChangeEnd();
          }}
          type={type}
          isInvalid={invalid}
          errorMessage={error?.message}
          validationBehavior="aria"
        />
      )}
    />
  );
};

export default FormTextField;
